<template>
  <div class="projects">

    <ImportLog :show="importDialog" :channelId="'demo'"></ImportLog>

    <v-toolbar color="transparent" flat>
      <v-toolbar-title>Projects</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn :to="{ name: 'new-project' }" exact text>Add new project</v-btn>
    </v-toolbar>

    <v-data-table
    :headers="headers"
    :items="projects"
    :loading="loading"
    :itemsPerPage="50"
    :footer-props="{ itemsPerPageOptions: [50,100,-1]}"
    class="elevation-1"
    >

    <template v-slot:item.name="{ item }">
      <router-link class="text-decoration-none" :to="{ name: 'entities', params: { projectId: item.id } }">
        {{ item.display_name }}
      </router-link>
      <div class="caption">{{ item.domains[0] }}</div>
    </template>

    <template v-slot:item.enabled_count="{ item }">
      {{ item.enabled_count }}
      <span class="quota">({{ item.enabled_rate | numberToPercentage }})</span>
    </template>

    <template v-slot:item.paused_count="{ item }">
      {{ item.paused_count }}
      <span class="quota">({{ item.paused_rate | numberToPercentage }})</span>
    </template>

    <template v-slot:item.broken_count="{ item }">
      {{ item.broken_count }}
      <span v-if="item.broken_rate" class="quota">({{ item.broken_rate | numberToPercentage }})</span>
    </template>

    <template v-slot:item.scope="{ item }">
      <v-chip v-if="item.parent_name" label outlined small>{{ item.parent_name }}</v-chip>
      <v-chip v-else label outlined small>{{ item.scope }}</v-chip>
    </template>

    <template v-slot:item.checks="{ item }">
      <CheckIcon :key="type" v-for="type in item.check_types" :type="type" />
    </template>

    <template v-slot:item.imported_at="{ item }">
      {{ item.imported_at | timeAgo }}
    </template>

    <template v-slot:item.previous_paused_change="{ item }">
      <ChangeIndicator :value="item.previous_paused_change" />
    </template>

    <template v-slot:item.action="{ item }">

      <v-btn @click="startImport(item)" text icon>
        <v-icon small>mdi-sync</v-icon>
      </v-btn>

      <v-btn @click="remove(item)" text icon>
        <v-icon small>mdi-delete</v-icon>
      </v-btn>

    </template>

    </v-data-table>

  </div>
</template>

<script>

import ImportLog from '@/components/ImportLog'
import ChangeIndicator from '@/components/ChangeIndicator'
import CheckIcon from '@/components/CheckIcon'

export default {
  name: 'projects',
  components: { ImportLog, ChangeIndicator, CheckIcon },
  props: ['accountId'],
  data () {
    return {
      headers: [
        { text: '#', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Scope', value: 'scope' },
        { text: 'Checks', value: 'checks' },
        { text: 'Enable entities ', value: 'enabled_count' },
        { text: 'Paused entities', value: 'paused_count' },
        { text: 'Broken pages', value: 'broken_count' },
        { text: 'Imported at', value: 'imported_at' },
        { text: 'Paused change/wk.', value: 'previous_paused_change' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      loading: false,
      importDialog: false
    }
  },
  created () {
    this.$store.dispatch('projects/getProjects', { accountId: this.accountId })
  },
  computed: {
    projects () {
      return this.$store.state.projects.all || []
    },
  },
  methods: {
    remove (item) {
      if(confirm('Are you sure?')) {
        this.$store.dispatch('projects/delProject', { id: item.id })
      }
    },
    startImport () {
      this.importDialog = true
    }
  }
}

</script>

<style scoped>

.quota { font-size: 0.8em; color: #6b6b6b; }

</style>
